export default __webpack_public_path__ + "static/media/loader.50c1a51d.svg";